import {combineReducers} from "redux";

import version from "./version";
import cartReducer from "./cart";
import currencyReducer from "./currency";
import mobileMenuReducer from "./mobile-menu";
import sidebarReducer from "./sidebar";
import wishlistReducer from "./wishlist";
import customerReducer from "./customer";
import tokenReducer from "./token";
import generalReducer from "./general";
import walletReducer from "./walletConnect";
import getProviderReducer from "./getprovider";
import addressReducer from "./addresses";
import smartSearchReducer from "./smart-search";
import checkoutReducer from "./checkout";
import formBuilderReducer from "./formbuilder";
import ordersReducer from "./orders/ordersReducer";
import productReducer from "./product";

export default combineReducers({
    version: (state = version) => state,
    cart: cartReducer,
    currency: currencyReducer,
    mobileMenu: mobileMenuReducer,
    sidebar: sidebarReducer,
    wishlist: wishlistReducer,
    customer: customerReducer,
    cartToken: tokenReducer,
    general: generalReducer,
    wall: walletReducer,
    provider: getProviderReducer,
    addresses: addressReducer,
    smartSearch: smartSearchReducer,
    checkout: checkoutReducer,
    formBuilder: formBuilderReducer,
    orders: ordersReducer,
    product: productReducer
});
